import { useScrollWatchdog } from '@/hooks/useScrollWatchdog';

/**
 * ScrollWatchdog Component
 * 
 * Monitors and enforces scroll state to prevent scroll-locking bugs.
 * - Runs on mount, route change, and visibility change
 * - Uses intervals to continuously enforce unlocked state when no modal/menu is open
 * - Provides debug panel when ?debugScroll=1 is in URL
 * - Logs Build ID to console for verification
 */
const ScrollWatchdog = () => {
  useScrollWatchdog();
  return null;
};

export default ScrollWatchdog;
